import React from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import styled from "styled-components";
import { PRIMARY,SECONDARY } from "../../const/colors";
import Grid from '@mui/material/Grid';
import he from 'he';
import DOMPurify from 'dompurify'; 
import CloseIcon from '@mui/icons-material/Close';
const scrollbarStyle = `
  ::-webkit-scrollbar {
    width: 12px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffce05;
  }
  ::-webkit-scrollbar-track {
    background-color: #0c0e1e;
  }
`;
const DetailModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: #0c0e1e;
  color: white;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  width: 80%;
  button {
    background-color: ${PRIMARY}!important;
    color: rgb(12, 14, 30);
    border: none;
    font-weight: 700;
    padding: 0.7rem 1.5rem;
    margin-bottom: 1rem;
    box-shadow: rgb(128, 103, 4) 0px 0px 14px;
    transition: transform 0.3s ease 0s;
    font-size: 16px;
    border-radius:0px;
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    margin: 0 auto;
    &:hover{
      transform: scale(1.1);
      transition: transform 0.3s ease 0s;
    }
  }
  .item{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  @media screen and (max-width: 768px) {
    width: 95%;
    top: 54%;
    height: 85%;
    justify-content: start;
    button{
      min-width: 35px;
    }
  }
`;

const ModalImage = styled.img`
  width: 100%;
  margin-bottom: 10px;
  @media screen and (max-width: 768px) {
    max-width: 210px;
    margin: 0 auto;
  }
`;
const ContentTitle = styled.div`
  background: rgb(29, 31, 32);
  position: relative;
  border-radius: 3px;
  display: inline-block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  margin-bottom: 20px;
  &:after {
    content: '';
    position: absolute;
    top: calc(-1 * 3px);
    left: calc(-1 * 3px);
    height: calc(100% + 3px * 2);
    width: calc(100% + 3px * 2);
    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
    border-radius: calc(2 * 3px);
    z-index: -1;
    animation: animatedgradient 3s ease alternate infinite;
    background-size: 300% 300%;
  }

  @keyframes animatedgradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`
const Title = styled.h1`
  width: 100%;
  text-align: center;
  display: block;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    font-size: 22px;
  }
  &.shine {
    background: -webkit-gradient(linear, 0% 0%, 100% 0%, from(rgb(0 0 0)), to(rgb(34, 34, 34)), color-stop(0.5, rgb(255 206 5))) 0px 0px / 150px 150px no-repeat text rgb(34, 34, 34);
    color: #ffffff00;
    animation-name: shine;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    text-shadow: rgb(255 206 5 / 50%) 0px 0px 0px;
  }
  
  @keyframes shine {
    0%, 10% {
      background-position: -1000px;
    }
    20% {
      background-position: top left;
    }
    90% {
      background-position: top right;
    }
    100% {
      background-position: 1000px;
    }
  }
`;

const Description = styled.code`
  margin-bottom: 15px;
  line-height: 1.5;
  width: 100%;
  text-align: justify;
  overflow: hidden;
  overflow-y: scroll;
  max-height: 280px;
  ${scrollbarStyle}
  @media screen and (max-width: 768px){
    margin-bottom: 15px;
    line-height: 1.5;
    width: 100%;
    max-height: 150px;
    height: 100%;
    padding-right: 5px;
  }
  @media screen and (min-height: 670px){
    max-height: 330px;
  }
`;

const DetailModal = ({ open, handleClose, title, description, imageUrl }) => {
  // ejemplo 1 
  const data = he.decode(description);
  return (
    <Modal open={open} onClose={handleClose}>
      <DetailModalContainer>
        <Grid container spacing={4}>
          <Grid item className="item" xs={12} md={4}>
            <ModalImage src={imageUrl} alt={title} />
          </Grid>
          <Grid item className="item" xs={12} md={8}>
            <ContentTitle>
              <Title className="shine">{title}</Title>
            </ContentTitle>
            <Description dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(data ,{ USE_PROFILES: { html: true } })}}/>
            <Button onClick={handleClose}><CloseIcon/></Button>
          </Grid>
        </Grid>
      </DetailModalContainer>
      
    </Modal>
  );
};

export default DetailModal;
